import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'
import { createGetWording } from '@v4/utils/wordings'

const useWordings = namespace => {
	const { t, ready } = useTranslation(namespace)

	const getWording = useMemo(() => {
		return createGetWording(t)
	}, [t])

	return { getWording, ready }
}

export default useWordings
